import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageDynamic from './LegalPageDynamic.jsx';

const TermsOfServiceFallback = ({ backTo = '/', backLabel = 'トップに戻る', embedded = false }) => {
  const currentYear = new Date().getFullYear();
  const lastUpdated = '2026年2月3日';
  const pageClassName = embedded ? 'hub-legal-page hub-legal-page--embedded' : 'hub-legal-page';

  return (
    <div className={pageClassName}>
      <div className="hub-legal-container">
        <div className="hub-legal-header">
          <Link to={backTo} className="hub-legal-back">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 20, height: 20 }}>
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            {backLabel}
          </Link>
          <h1>利用規約</h1>
          <p className="hub-legal-updated">最終更新日: {lastUpdated}</p>
        </div>

        <div className="hub-legal-content">
          <section>
            <h2>第1条（適用）</h2>
            <p>
              本利用規約（以下「本規約」といいます）は、株式会社ConvergePartners（以下「当社」といいます）が
              提供するSynapse Platform および Synapseシリーズ（以下「本サービス」といいます）の利用に関する条件を定めるものです。
              本サービスを利用されるお客様（以下「ユーザー」といいます）には、本規約に同意いただいた上で
              本サービスをご利用いただきます。
            </p>
          </section>

          <section>
            <h2>第2条（定義）</h2>
            <p>本規約において使用する用語の定義は、以下のとおりとします。</p>
            <ul>
              <li>「本サービス」とは、当社が提供するSynapse Platform および Synapseシリーズ並びにこれらに付随するサービスをいいます。</li>
              <li>「ユーザー」とは、本規約に同意の上、本サービスを利用する法人または個人をいいます。</li>
              <li>「クリニックアカウント」とは、ユーザーが本サービスを利用するために登録するクリニック単位のアカウントをいいます。</li>
              <li>「ユーザーアカウント」とは、クリニックアカウントに紐付く個別のユーザーアカウントをいいます。</li>
              <li>「ライセンス」とは、本サービスの特定の機能を利用するための権利をいいます。</li>
            </ul>
          </section>

          <section><h2>第3条（アカウント登録）</h2><p>本規約に同意の上、当社所定の方法によりアカウント登録を行うものとします。</p></section>
          <section><h2>第4条（アカウント管理）</h2><p>ユーザーは、自己の責任においてアカウント情報を管理するものとします。</p></section>
          <section><h2>第5条（サービスの利用）</h2><p>ユーザーは、本規約及び関連するガイドラインに従い、本サービスを利用するものとします。</p></section>
          <section><h2>第6条（料金及び支払い）</h2><p>本サービスの利用料金は、当社が別途定める料金表に基づくものとします。</p></section>
          <section><h2>第7条（禁止事項）</h2><p>ユーザーは、法令または公序良俗に違反する行為等を行ってはなりません。</p></section>
          <section><h2>第8条（サービスの変更・中断・終了）</h2><p>当社は、事前の通知なく、本サービスの内容を変更することがあります。</p></section>
          <section><h2>第9条（知的財産権）</h2><p>本サービスに関する知的財産権は、当社または正当な権利者に帰属します。</p></section>
          <section><h2>第10条（個人情報の取扱い）</h2><p>当社は、別途定めるプライバシーポリシーに従い適切に取り扱います。</p></section>
          <section><h2>第11条（免責事項）</h2><p>当社は、本サービスの利用により生じた損害について、故意または重大な過失による場合を除き責任を負いません。</p></section>
          <section><h2>第12条（利用停止・登録抹消）</h2><p>ユーザーが本規約に違反した場合、利用停止または登録抹消を行うことがあります。</p></section>
          <section><h2>第13条（退会）</h2><p>ユーザーは、当社所定の方法により、いつでも退会することができます。</p></section>
          <section><h2>第14条（規約の変更）</h2><p>当社は、必要と判断した場合、本規約を変更することがあります。</p></section>
          <section><h2>第15条（通知）</h2><p>当社からユーザーへの通知は、本サービス上での掲示等により行うものとします。</p></section>
          <section><h2>第16条（権利義務の譲渡禁止）</h2><p>ユーザーは、当社の承諾なく権利義務を第三者に譲渡してはなりません。</p></section>
          <section><h2>第17条（分離可能性）</h2><p>条項が無効と判断された場合でも、他の条項の有効性には影響しません。</p></section>
          <section><h2>第18条（準拠法・管轄）</h2><p>本規約は日本法に準拠し、東京地方裁判所を専属的合意管轄裁判所とします。</p></section>
          <section>
            <h2>第19条（お問い合わせ）</h2>
            <p>本規約に関するお問い合わせは、下記までご連絡ください。</p>
            <div className="hub-legal-contact">
              <p><strong>株式会社ConvergePartners</strong></p>
              <p>ウェブサイト：<a href="https://www.converge-p.co.jp" target="_blank" rel="noopener noreferrer">https://www.converge-p.co.jp</a></p>
            </div>
          </section>
        </div>

        <div className="hub-legal-footer">
          <p>&copy; {currentYear} Synapse by ConvergePartners Inc.</p>
        </div>
      </div>
    </div>
  );
};

const TermsOfServicePage = ({
  backTo = '/',
  backLabel = 'トップに戻る',
  embedded = false,
} = {}) => (
  <LegalPageDynamic
    docType="terms"
    fallbackTitle="利用規約"
    backTo={backTo}
    backLabel={backLabel}
    embedded={embedded}
    fallbackContent={
      <TermsOfServiceFallback backTo={backTo} backLabel={backLabel} embedded={embedded} />
    }
  />
);

export default TermsOfServicePage;
